import { render, staticRenderFns } from "./section-user-info.vue?vue&type=template&id=63e9872b&scoped=true"
import script from "./section-user-info.vue?vue&type=script&lang=js"
export * from "./section-user-info.vue?vue&type=script&lang=js"
import style0 from "./section-user-info.vue?vue&type=style&index=0&id=63e9872b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e9872b",
  null
  
)

export default component.exports